import React from "react";
import { useNavigate } from "react-router";
import {
  FcCalendar,
  FcClapperboard,
  FcConferenceCall,
  FcNews,
  FcPicture,
  FcReading,
  FcShop,
  FcStatistics,
} from "react-icons/fc";
import TopAddressBar from "./top_address_bar";

const HeaderMenu = () => {
  const navigate = useNavigate();
  const formattedDate = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <>
      {/* for larger screens */}

      <TopAddressBar />

      <header class="navbar navbar-expand-md d-print-none">
        <div class="container-xl">
          {/* <!-- BEGIN NAVBAR TOGGLER --> */}

          <div className="d-block d-lg-none d-md-none  ms-0 d-flex align-items-center">
            <button
              class="navbar-toggler collapsed border border-secondary"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar-menu"
              aria-controls="navbar-menu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            <a
              href="/"
              aria-label="Tabler"
              className="d-block d-lg-none d-md-none  ms-1"
            >
              <img
                height={105}
                width={105}
                src="https://res.cloudinary.com/dfhuelkzw/image/upload/v1763957144/kryzen_info-logo_iudzc9.png"
                alt=""
              />
            </a>
          </div>
          {/* <!-- END NAVBAR TOGGLER -->
          <!-- BEGIN NAVBAR LOGO --> */}
          <div class="navbar-brand navbar-brand-autodark  d-none-navbar-horizontal pe-0 pe-md-3">
            <a
              href="/"
              aria-label="Tabler"
              className="d-none d-lg-block d-md-block  ms-0"
            >
              <img
                height={105}
                width={105}
                src="https://res.cloudinary.com/dfhuelkzw/image/upload/v1763957144/kryzen_info-logo_iudzc9.png"
                alt=""
              />
            </a>
          </div>
          <div class="navbar-nav flex-row">
            <div class="nav-item d-none d-md-block d-lg-block">
              <h3 className="mt-2 text-lime fs-2 "> {formattedDate}</h3>
            </div>
          </div>
          {/* <!-- END NAVBAR LOGO --> */}
          <div class="navbar-nav flex-row order-md-last">
            <div class="d-none d-md-flex"></div>
            <div class="nav-item dropdown">
              <a href="#newsletter">
                <button className="btn btn-green text-white fs-lg-2">
                  Join <span className="ms-1">Newsletter</span>
                </button>
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* For smaller screesn */}
      <header class="navbar-expand-md">
        <div class="navbar-collapse collapse" id="navbar-menu" style={{}}>
          <div class="navbar">
            <div class="container-xl">
              <div class="row flex-column flex-md-row flex-fill align-items-center">
                <div class="col">
                  {/* <!-- BEGIN NAVBAR MENU --> */}
                  <ul class="navbar-nav">
                    <li class="nav-item">
                      <a class="nav-link" href="/">
                        <span class="nav-link-icon d-md-none d-lg-inline-block">
                          <FcShop size={30} />
                        </span>
                        <span class="nav-link-title"> Home </span>
                      </a>
                    </li>

                    <li class="nav-item">
                      <a class="nav-link" href="/vacancies">
                        <span class="nav-link-icon d-md-none d-lg-inline-block">
                          <FcReading size={30} />
                        </span>
                        <span class="nav-link-title">Vacancies </span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="/gallery">
                        <span class="nav-link-icon d-md-none d-lg-inline-block">
                          <FcPicture size={30} />
                        </span>
                        <span class="nav-link-title">Gallery </span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="/hydroponic-upcoming-events">
                        <span class="nav-link-icon d-md-none d-lg-inline-block">
                          <FcCalendar size={30} />
                        </span>
                        <span class="nav-link-title">Calender </span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="/blog">
                        <span class="nav-link-icon d-md-none d-lg-inline-block">
                          <FcNews size={30} />
                        </span>
                        <span class="nav-link-title">Blogs </span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="/news">
                        <span class="nav-link-icon d-md-none d-lg-inline-block">
                          <FcNews size={30} />
                        </span>
                        <span class="nav-link-title">News </span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="https://kryzen.com/farm-training/"
                      >
                        <span class="nav-link-icon d-md-none d-lg-inline-block">
                          <FcStatistics size={30} />
                        </span>
                        <span class="nav-link-title"> Farm Training </span>
                      </a>
                    </li>

                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="https://alpha.kryzen.com/hydroponic-webinar?theme=light"
                      >
                        <span class="nav-link-icon d-md-none d-lg-inline-block">
                          <FcClapperboard size={30} />
                        </span>
                        <span class="nav-link-title"> Hydroponic Webinar </span>
                      </a>
                    </li>

                    <li class="nav-item">
                      <a class="nav-link" href="/hydroponic-masterclass">
                        <span class="nav-link-icon d-md-none d-lg-inline-block">
                          <FcConferenceCall size={30} />
                        </span>
                        <span class="nav-link-title">
                          {" "}
                          Hydroponic Masterclass{" "}
                        </span>
                      </a>
                    </li>
                  </ul>
                  {/* //   <!-- END NAVBAR MENU --> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default HeaderMenu;
